export const initialProjects = [
  {
    id: 'proj-1',
    title: 'E-Commerce Platform',
    description:
      'A full-featured e-commerce platform with shopping cart, user authentication, and payment integration.',
    tags: ['React', 'Node.js', 'MongoDB', 'Tailwind'],
    links: {
      demo: '#',
      github: '#',
    },
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    featured: true,
  },
  {
    id: 'proj-2',
    title: 'Portfolio Website',
    description:
      'A responsive portfolio website showcasing projects and skills with clean design and smooth animations.',
    tags: ['React', 'Tailwind', 'JavaScript', 'Responsive'],
    links: {
      demo: '#',
      github: '#',
    },
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    featured: false,
  },
  {
    id: 'proj-3',
    title: 'Task Management App',
    description:
      'A productivity app for managing daily tasks with drag-and-drop functionality and progress tracking.',
    tags: ['React', 'CSS', 'Local Storage', 'JavaScript'],
    links: {
      demo: '#',
      github: '#',
    },
    image: 'https://images.unsplash.com/photo-1611224923853-80b023f02d71?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    featured: false,
  },
  {
    id: 'proj-4',
    title: 'Weather Dashboard',
    description: 'A weather dashboard providing current weather conditions and a 5-day forecast for any city.',
    tags: ['React', 'OpenWeather API', 'Tailwind'],
    links: { demo: '#', github: '#' },
    image: 'https://images.unsplash.com/photo-1504608524841-42fe6f032b4b?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    featured: false,
  },
  {
    id: 'proj-5',
    title: 'Social Media App',
    description: 'A social networking platform to connect with friends, share updates, and discover new communities.',
    tags: ['Next.js', 'Firebase', 'Tailwind'],
    links: { demo: '#', github: '#' },
    image: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    featured: false,
  },
  {
    id: 'proj-6',
    title: 'Finance Tracker',
    description: 'A personal finance application to track expenses, set budgets, and visualize financial goals.',
    tags: ['React', 'Node.js', 'PostgreSQL'],
    links: { demo: '#', github: '#' },
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    featured: false,
  }
];

const STORAGE_KEY = 'portfolio_custom_projects_v1';

export const getProjects = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      const parsed = JSON.parse(saved);
      if (Array.isArray(parsed) && parsed.length > 0) {
        return parsed;
      }
    }
  } catch (err) {
    console.error('Failed to load projects from localStorage:', err);
  }
  return initialProjects;
};

export const saveProjects = (projectsList) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(projectsList));
    // Dispatch custom event to sync components across the app
    window.dispatchEvent(new Event('projects_updated'));
  } catch (err) {
    console.error('Failed to save projects to localStorage:', err);
  }
};

export const resetProjectsToDefault = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
    window.dispatchEvent(new Event('projects_updated'));
  } catch (err) {
    console.error('Failed to reset projects:', err);
  }
};
